import { Injectable } from '@angular/core';
import { MatSnackBar } from '@angular/material/snack-bar';

@Injectable({ providedIn: 'root' })
export class NotifyService {
  constructor(private snackBar: MatSnackBar) {}

  info(message: string) {
    this.show(message, 'notify-info');
  }

  success(message: string) {
    this.show(message, 'notify-success');
  }

  warning(message: string) {
    this.show(message, 'notify-warning');
  }

  error(message: string) {
    this.show(message, 'notify-danger');
  }

  private show(message: string, panelClass: string) {
    this.snackBar.open(message, '✕', {
      duration: 5000,
      panelClass,
      horizontalPosition: 'right',
      verticalPosition: 'top'
    });
  }
}
